// extracted by mini-css-extract-plugin
export default {"home":"updateSubject_home__khiul","hr":"updateSubject_hr__hZdYl","home2":"updateSubject_home2__GfaQq","main":"updateSubject_main__+xyER"};